import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Link, useHref } from "react-router-dom";
import styled from "styled-components";
import authContext from "../store/authContext";

const Header = () => {
	const [getElement, setElement] = useState("");
	const [rotates, setRotates] = useState(false);
	const [getEle, setEle] = useState("");
	const ctx = useContext(authContext);
	const [isClicked, setIsClicked] = useState(false);
	const [helper, setHelper] = useState([]);
	const tmdb_api = "0bcafd5b459497ec53d81e9fc940f86d";

	const inputHandler = (event) => {
		console.log(event.target.value);

		setElement(event.target.value);
		ctx.SearchVal({ data: event.target.value });

		axios
			.get(
				`https://api.themoviedb.org/3/search/multi?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&query=${event.target.value}&page=1&include_adult=false`
			)
			.then((res) => {
				setHelper([res.data.results]);
			});
	};
	const finalInputHandler = () => {
		// getElement.length > 0
		// 	? setEle(() => {
		// 			return getElement;
		// 	  })
		// 	: window.alert("You should type atleast");
		setElement();
	};

	console.log(getEle);

	console.log(helper);

	const shrink = () => {
		document.getElementById("shrink").style.display = "none";
		document.getElementById("inputSpan").style.display = "block";
	};
	const rotate = () => {
		if (rotates) {
			setRotates(false);
		} else {
			setRotates(true);
		}
	};
	useEffect(() => {
		setRotates(false);
	}, []);
	return (
		<Nav className="nav">
			<Link className="logo" to={"/"}>
				<Logo src="https://arsh3686.github.io/DisneyPlus/images/logo.svg" />
			</Link>
			<NavMenu className="middle">
				<Link className="hide" to={"/originals"}>
					<img src="./images/original-icon.svg" alt="j" />
					<span>ORIGINALS</span>
				</Link>
				<Link className="hide" to={"/movies"}>
					<img src="./images/movie-icon.svg" alt="j" />
					<span>MOVIE</span>
				</Link>
				<Link className="hide" to={"/series"}>
					<img src="./images/series-icon.svg" alt="j" />
					<span>SERIES</span>
				</Link>

				<Link className="hide" to={"/watchlist"}>
					<img src="./images/watchlist-icon.svg" alt="j" />
					<span>WATCHLIST</span>
				</Link>

				<Link className="search" to={"/search"}>
					<input
						onChange={(e) => inputHandler(e)}
						placeholder="Search"
						// value={getElement}
					/>

					{/* <img
						src="./images/search-icon.svg"
						alt="j"
						onClick={finalInputHandler}
					/> */}

					{/* <span id="shrink" onClick={shrink}>
							SEARCH
						</span> */}
				</Link>
			</NavMenu>
			<Link className="account" to="./login">
				<UserImg
					className="userImg"
					src="https://arsh3686.github.io/DisneyPlus/images/Eternals.webp"
				/>
			</Link>

			<Bread isRotated={rotates} onClick={rotate} className="bread">
				<div className="bread_line bread_line_cross1"></div>
				<div className="bread_line bread_line_cross2"></div>
				<div className="linkContainer">
					<Link className="rotateItem" to={"/originals"}>
						<img src="./images/original-icon.svg" alt="j" />
						<span>ORIGINALS</span>
					</Link>
					<Link className="rotateItem" to={"/movies"}>
						<img src="./images/movie-icon.svg" alt="j" />
						<span>MOVIE</span>
					</Link>
					<Link className="rotateItem" to={"/series"}>
						<img src="./images/series-icon.svg" alt="j" />
						<span>SERIES</span>
					</Link>

					<Link className="rotateItem" to={"/watchlist"}>
						<img src="./images/watchlist-icon.svg" alt="j" />
						<span>WATCHLIST</span>
					</Link>
				</div>
			</Bread>
		</Nav>
	);
};

export default Header;
const Bread = styled.div`
	position: relative;
	cursor: pointer;
	padding-right: 44px;
	// width: 20px;
	height: 15px;
	& .bread_line {
		width: ${(props) => (props.isRotated === true ? "16px" : "16px")};
		height: 1px;
		margin-top: ${(props) => (props.isRotated === true ? "-1px" : "3px")};
		background-color: #fff;
	}
	// 	& .bread_line {
	// 		margin-top: -1px;
	// 	}
	& .bread_line_cross2 {
		transform: rotate(
			${(props) => (props.isRotated === true ? "45deg" : "0deg")}
		);
	}
	& .bread_line_cross1 {
		transform: rotate(
			${(props) => (props.isRotated === true ? "-45deg" : "0deg")}
		);
	}
	& .rotateItem {
		display: flex;
		align-items: center;
	}
	& .linkContainer {
		${(props) =>
			props.isRotated === true
				? `
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		position: absolute;
		background: #0c111b;
		// background: green;
		border-radius: 8px;
		// justify-content: center;
		// align-items: center;
		padding: 4px 6px;
		right: 0px;
		margin-top: 16px;
		width: 100px;
		height: 110px;
		z-index: 100000;
	 `
				: `display:none;`}
	}
	a {
		color: inherit;
	}
	& img {
		width: 15px;
		// padding-right: 2px;
		margin-right: 3px;
	}
	& span {
		font-size: 13px;
	}
`;
const Nav = styled.nav`
	height: 60px;
	width: 100vw;
	background: #0c111b;
	display: flex;
	align-items: center;

	// background-color: indigo;
	padding: 0 36px;
	z-index: 100000;
	& .logo {
		// width: 10%;
	}
	& .middle {
		width: 90%;
	}
	& .account {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	& .bread {
		display: none;
	}

	@media (max-width: 768px) {
		padding: 0 10px;
	}
	@media (max-width: 468px) {
		& .bread {
			display: block;
		}
		& .userImg {
			display: none;
		}
	}
`;

const Logo = styled.img`
	width: 70px;
	@media (max-width: 900px) {
		width: 50px;
	}
	@media (max-width: 700px) {
		width: 40px;
	}
`;

const NavMenu = styled.div`
	display: flex;
	align-items: center;

	// background: pink;
	flex: 1;
	& Link {
		color: inherit;
	}
	input {
		width: 80%;
		color: #fff;
		background-color: inherit;
		border-color: #fff;
		border-left: 0;
		border-right: 0;
		border-top: 0;
		outline: none;
		border-bottom: 1px solid #fff;
		transform: width 3s ease-in;
	}
	a {
		margin-left: 20px;
		display: flex;
		align-items: center;
		padding: 0 12px;
		cursor: pointer;
		img {
			height: 20px;
		}
		span {
			letter-spacing: 1.34px;
			font-size: 13px;
			margin-left: 5px;
			position: relative;
			color: white;
			&::after {
				content: "";
				height: 2px;
				position: absolute;
				left: 0;
				right: 0;
				background: white;
				width: 100%;
				bottom: -4px;
				transform-origin: left center;
				transform: scaleX(0);
				opacity: 0;
			}
		}

		&:hover {
			span:after {
				opacity: 1;
				transform: scaleX(1);
				transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
			}
		}
	}

	@media (max-width: 900px) {
		a {
			margin-left: 0;
			span {
				font-size: 12px;
			}
		}
	}
	@media (max-width: 700px) {
		a {
			margin-left: 0;
			img {
				height: 15px;
			}
			span {
				font-size: 10px;
			}
		}
	}

	@media (max-width: 512px) {
		a {
			margin-left: 0;
			padding: 0 6px;
			img {
				height: 15px;
			}
			span {
				font-size: 10px;
			}
		}
	}
	@media (max-width: 468px) {
		width: 100%;
		padding: 0 10px;
		& .hide {
			display: none;
		}
		& .search {
			width: 100%;
			display: block;
		}
		input {
			width: 95%;
		}
	}
`;

const UserImg = styled.img`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	object-fit: cover;
	cursor: pointer;
	@media (max-width: 900px) {
		width: 55px;
		height: 55px;
	}
	@media (max-width: 700px) {
		width: 40px;
		height: 40px;
	}
	@media (max-width: 468px) {
		display: none;
	}
`;
